import StateListenerRegistry from '../../../../react/features/base/redux/StateListenerRegistry';

import WildixUIEvents from '../../../service/WildixUIEvents';

/**
 * StateListenerRegistry provides a reliable way of detecting changes to
 * preferred layout state and dispatching additional actions.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/video-layout'].tileViewEnabled,
    /* listener */ (tileViewEnabled, store) => {
        if (APP.wildix.wizy && !tileViewEnabled) {
            setTimeout(() => {
                APP.wildix.eventEmitter.emit(WildixUIEvents.UPDATE_LOCAL_VIDEO);
            }, 50);
        }
    }
);
